import React from 'react';

interface IconProps {
  className?: string;
}

/** Green filled circle with a white tick. Decorative; hidden from assistive technology. */
const SuccessIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
    <circle cx="10" cy="10" r="10" fill="#0d8426" />
    <path d="M5.5 10.5l3 3 6-6.5" stroke="#ffffff" strokeWidth="2" fill="none" />
  </svg>
);

export default SuccessIcon;
